import React, { useEffect, useState, useCallback } from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout';
import DataTable from '../../components/common/DataTable';
import Pagination from '../../components/common/Pagination';
import { Loader, ErrorBanner } from '../../components/common/Feedback';
import * as auditLogsApi from '../../api/auditLogs';
import { formatDateTime } from '../../utils/format';

export default function AuditLogs() {
  const [rows, setRows] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(1);
  const [moduleFilter, setModuleFilter] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(() => {
    setLoading(true);
    auditLogsApi
      .listAuditLogs({ page, module: moduleFilter || undefined })
      .then((res) => {
        setRows(res.data);
        setPagination(res.pagination);
      })
      .catch((err) => setError(err.response?.data?.message || 'Failed to load audit logs.'))
      .finally(() => setLoading(false));
  }, [page, moduleFilter]);

  useEffect(() => {
    load();
  }, [load]);

  const columns = [
    { key: 'createdAt', label: 'Timestamp', render: (r) => formatDateTime(r.createdAt) },
    { key: 'actorName', label: 'Actor', render: (r) => r.actorName || '-' },
    { key: 'actorType', label: 'Type' },
    { key: 'action', label: 'Action' },
    { key: 'module', label: 'Module' },
    { key: 'description', label: 'Description' },
    { key: 'ipAddress', label: 'IP Address', render: (r) => r.ipAddress || '-' },
  ];

  return (
    <DashboardLayout title="Audit Logs">
      <div className="page-header">
        <div>
          <h1 className="heading">Audit Trail</h1>
          <p className="page-subtext">Every login, password change, document upload, invoice update and more is recorded here.</p>
        </div>
        <a className="btn-link" href={auditLogsApi.auditLogExportUrl({ module: moduleFilter || undefined })} target="_blank" rel="noreferrer">Export CSV</a>
      </div>

      <ErrorBanner message={error} />

      <div className="filter-bar">
        <input type="text" placeholder="Filter by module (e.g. Invoice Management)" value={moduleFilter} onChange={(e) => { setModuleFilter(e.target.value); setPage(1); }} />
      </div>

      {loading ? (
        <Loader text="Loading audit logs..." />
      ) : (
        <>
          <DataTable columns={columns} rows={rows} getRowKey={(r) => r.id} emptyMessage="No audit log entries found." />
          <Pagination pagination={pagination} onPageChange={setPage} />
        </>
      )}
    </DashboardLayout>
  );
}
